// @todo rewrite mutations outside vuex
// eslint-disable-next-line
import PluginDataLayer from '~/src/plugins/vuex/dataLayer';
import PluginGoogleServices from '~/src/plugins/vuex/googleServices';

export const strict = false;

export const plugins = [PluginDataLayer, PluginGoogleServices];
